import { GetState } from '../../store'

export const makeFolderObject = (title: string) => {
  const folder: APIArticleUpdate = {
    type: 'folder',
    parent_id: null,
    title,
    subtitle: null,
    body: null,
    published_at: new Date().toISOString(),
    archived_at: null,
    media_ids: [],
    tags: [],
    order: 0
  }
  return folder
}

export const sortItems = (items: APIArticleItem[]) => {
  if (!items || !Array.isArray(items)) {
    return []
  }

  return [...items].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
}

export const getSortedItems = (getState: GetState, parent?: string) => {
  const { root, articles } = getState().article

  let items: APIArticleItem[] = []
  if (!parent) {
    items = root?.items ?? []
  } else {
    items = articles[parent]?.items ?? []
  }

  const sorted = sortItems(items)
  return sorted
}

export const getNewOrder = (
  sorted: APIArticleItem[],
  target: string,
  after: boolean
) => {
  const targetArticleIdx = sorted.findIndex(item => item.id === target)
  const targetArticle = sorted[targetArticleIdx]
  const nextArticleIdx = targetArticleIdx + (after ? 1 : -1)

  const ORDER_DIFF = 2048
  let newOrder = 0
  if (nextArticleIdx < 0) {
    newOrder = (targetArticle.order ?? 0) - ORDER_DIFF
  } else if (nextArticleIdx >= sorted.length) {
    newOrder = (targetArticle.order ?? 0) + ORDER_DIFF
  } else {
    const nextArticle = sorted[nextArticleIdx]
    newOrder = ((targetArticle.order ?? 0) + (nextArticle.order ?? 0)) / 2
  }

  return Math.round(newOrder)
}
